import DayOff from '../DayOff/DayOff';
import Lunch from '../Lunch/Lunch';
import { Card } from '../ui';

export default function Revenue() {
  return (
    <div className="flex flex-col gap-6">
      <Card>
        <Card.Header>
          <h2 className="text-sm font-semibold text-text-primary">Folgas</h2>
        </Card.Header>
        <Card.Body>
          <DayOff />
        </Card.Body>
      </Card>

      <Card>
        <Card.Header>
          <h2 className="text-sm font-semibold text-text-primary">Horários de Almoço</h2>
        </Card.Header>
        <Card.Body>
          <Lunch />
        </Card.Body>
      </Card>
    </div>
  );
}
